import { useNavigate } from 'react-router-dom';
import { toIcons } from '../../consts/Paths';
import MainContext from '../../context/MainContext';
import useToggle from '../../hooks/useToggle';
import { getUserStatusStyle } from '../../utils/getMethods';
import Avatar from '../misc/Avatar';
import { useContext, useMemo, useState } from 'react';
import useIsMobile from '../../hooks/useIsMobile';
import { getRandomBgColor } from '../../utils/others';
import ProposalModal from '../modals/ProposalModal';
import { possible_statuses } from '../../consts/possible_statuses';

const UserCard = (props: any) => {
    const { isMobile } = useIsMobile();
    const navigate = useNavigate();
    const deleteToggler = useToggle(false);
    const status = useMemo(() => {
        const isAdmin = props.user?.roles.some((e: any) => e.role === possible_statuses.userType.admin);
        return isAdmin ? 'Admin' : 'Normal';
    }, [props.user?.roles]);

    const { setUserTreated } = useContext(MainContext);

    // const handleOnCardClick = () => {
    //     setUserTreated(props.user);
    //     navigate(`/settings/user/${props.user.id}`);
    // };

    // const handelOnDeleteClick = () => {
    //     setUserTreated(props.user);
    //     props.deleteToggler.toggle();
    // };

    const handleOnClickEdit = () => {
        props.showPopup(true);
        props.setOtherUser(props.user);
    };

    return (
        <div className='user-card' onMouseEnter={deleteToggler.toggle} onMouseLeave={deleteToggler.toggle}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {!isMobile && (
                    <div style={{ marginRight: '31px' }}>
                        <Avatar user={props.user} size={56} bgColor={props.bgColor} />
                    </div>
                )}
                <p
                    className='user-card-field'
                    style={{
                        width: '150px',
                        marginLeft: isMobile ? '' : '10px',
                    }}
                >
                    {`${props.user.name}`}
                </p>
                {!isMobile && (
                    <p className='user-card-field' style={{ width: '200px', marginLeft: '130px' }}>
                        {props.user.email}
                    </p>
                )}
                <div className='user-card-field' style={{ marginLeft: isMobile ? '18px' : '136px' }}>
                    <div
                        className='user-card-status-box'
                        style={{
                            backgroundColor: getUserStatusStyle(props.user.status)?.bgColor,
                            cursor: 'pointer',
                            padding: isMobile ? '0' : '0',
                        }}
                    >
                        <p
                            className='user-card-status-text'
                            style={{
                                color: getUserStatusStyle(props.user.status)?.textColor,
                            }}
                        >
                            {status}
                        </p>
                    </div>
                </div>
                <div className='user-card-field' style={{ marginLeft: isMobile ? '18px' : '136px' }}>
                    <div
                        className='user-card-status-box'
                        style={{
                            backgroundColor: getUserStatusStyle(props.user.status)?.bgColor,
                            cursor: 'pointer',
                            padding: isMobile ? '0' : '0',
                        }}
                    >
                        <button className='modal-button' onClick={handleOnClickEdit}>
                            <p className='modal-button-text'>Edit</p>
                        </button>
                    </div>
                </div>
            </div>
            {/* {(deleteToggler.isToggled || isMobile) && (
                <img
                    style={{
                        cursor: 'pointer',
                        marginLeft: 'auto',
                        marginRight: isMobile ? '' : '20px',
                    }}
                    src={`${toIcons}/close.svg`}
                    onClick={handelOnDeleteClick}
                />
            )} */}
        </div>
    );
};
export default UserCard;
